<nav class="sidebar" [class.sidebar--collapsed]="!isSidebarExpanded" id="appSidebar">

  <!-- ===== HEADER: Logo  ===== -->
  <div class="sidebar__header">
    <a *ngIf="isSidebarExpanded" (click)="navigateTo('/home')" class="sidebar__logo-link cursor-pointer">
      <img src="assets/images/logo-unicloud.png" alt="UniHRM Logo" class="sidebar__logo-img" />
    </a>
    <button class="sidebar__toggle" (click)="toggleSidebar()" title="Toggle Sidebar">
      <i class="pi pi-chevron-left sidebar__toggle-icon" [class.sidebar__toggle-icon--rotated]="!isSidebarExpanded"></i>
    </button>
  </div>

  <!-- ===== BODY: Menu List (Tree-view) ===== -->
  <div class="sidebar__body">
    <ul class="sidebar__menu">
      <!-- Template render Icon SVG dùng ngSwitch -->
      <ng-template #svgIconFallback let-iconClass="iconClass" let-defaultIcon="defaultIcon">
        <!-- Đảm bảo nội dung căn giữa bằng thẻ wrapper cho ng-container nếu cần -->
        <span class="svg-icon-wrapper flex justify-center items-center">
          <ng-container [ngSwitch]="iconClass">
            <!-- 1. Tổng quan -->
            <svg *ngSwitchCase="'asset asset-tong-quan'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="rgb(33, 38, 51)" aria-hidden="true" data-slot="icon" class="w-[16PX] h-[17PX] shrink-0 ">
              <path fill-rule="evenodd"
                d="M3 6a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3v2.25a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3V6ZM3 15.75a3 3 0 0 1 3-3h2.25a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3v-2.25Zm9.75 0a3 3 0 0 1 3-3H18a3 3 0 0 1 3 3V18a3 3 0 0 1-3 3h-2.25a3 3 0 0 1-3-3v-2.25Z"
                clip-rule="evenodd"></path>
            </svg>
            <!-- 2. Danh mục -->
            <svg *ngSwitchCase="'asset asset-danh-muc'" viewBox="0 0 24 24" fill="rgb(33, 38, 51)" class="w-[16PX] h-[17PX]">
              <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
            </svg>
            <!-- 3. Tài sản -->
            <svg *ngSwitchCase="'asset asset-tai-san'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="rgb(33, 38, 51)" aria-hidden="true" data-slot="icon" class="w-[16PX] h-[17PX] shrink-0 opacity-60">
              <path d="M21 6.375c0 2.692-4.03 4.875-9 4.875S3 9.067 3 6.375 7.03 1.5 12 1.5s9 2.183 9 4.875Z"></path>
              <path
                d="M12 12.75c2.685 0 5.19-.586 7.078-1.609a8.283 8.283 0 0 0 1.897-1.384c.016.121.025.244.025.368C21 12.817 16.97 15 12 15s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.285 8.285 0 0 0 1.897 1.384C6.809 12.164 9.315 12.75 12 12.75Z">
              </path>
              <path
                d="M12 16.5c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 15.914 9.315 16.5 12 16.5Z">
              </path>
              <path
                d="M12 20.25c2.685 0 5.19-.586 7.078-1.609a8.282 8.282 0 0 0 1.897-1.384c.016.121.025.244.025.368 0 2.692-4.03 4.875-9 4.875s-9-2.183-9-4.875c0-.124.009-.247.025-.368a8.284 8.284 0 0 0 1.897 1.384C6.809 19.664 9.315 20.25 12 20.25Z">
              </path>
            </svg>
            <!-- 4. Kiểm kê tài sản -->
            <svg *ngSwitchCase="'asset asset-kiem-ke'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
              fill="rgb(33, 38, 51)" aria-hidden="true" data-slot="icon" class="w-[16PX] h-[17PX] shrink-0 opacity-60">
              <path
                d="M12.378 1.602a.75.75 0 0 0-.756 0L3 6.632l9 5.25 9-5.25-8.622-5.03ZM21.75 7.93l-9 5.25v9l8.628-5.032a.75.75 0 0 0 .372-.648V7.93ZM11.25 22.18v-9l-9-5.25v8.57a.75.75 0 0 0 .372.648l8.628 5.033Z">
              </path>
            </svg>
            <!-- 5. Quản lý -->
            <svg *ngSwitchCase="'asset asset-quan-ly'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="rgb(33, 38, 51)" aria-hidden="true"
              data-slot="icon" class="w-[16PX] h-[17PX] shrink-0 opacity-60">
              <path fill-rule="evenodd"
                d="M11.078 2.25c-.917 0-1.699.663-1.85 1.567L9.05 4.889c-.02.12-.115.26-.297.348a7.493 7.493 0 0 0-.986.57c-.166.115-.334.126-.45.083L6.3 5.508a1.875 1.875 0 0 0-2.282.819l-.922 1.597a1.875 1.875 0 0 0 .432 2.385l.84.692c.095.078.17.229.154.43a7.598 7.598 0 0 0 0 1.139c.015.2-.059.352-.153.43l-.841.692a1.875 1.875 0 0 0-.432 2.385l.922 1.597a1.875 1.875 0 0 0 2.282.818l1.019-.382c.115-.043.283-.031.45.082.312.214.641.405.985.57.182.088.277.228.297.35l.178 1.071c.151.904.933 1.567 1.85 1.567h1.844c.916 0 1.699-.663 1.85-1.567l.178-1.072c.02-.12.114-.26.297-.349.344-.165.673-.356.985-.57.167-.114.335-.125.45-.082l1.02.382a1.875 1.875 0 0 0 2.28-.819l.923-1.597a1.875 1.875 0 0 0-.432-2.385l-.84-.692c-.095-.078-.17-.229-.154-.43a7.614 7.614 0 0 0 0-1.139c-.016-.2.059-.352.153-.43l.84-.692c.708-.582.891-1.59.433-2.385l-.922-1.597a1.875 1.875 0 0 0-2.282-.818l-1.02.382c-.114.043-.282.031-.449-.083a7.49 7.49 0 0 0-.985-.57c-.183-.087-.277-.227-.297-.348l-.179-1.072a1.875 1.875 0 0 0-1.85-1.567h-1.843ZM12 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z"
                clip-rule="evenodd"></path>
            </svg>

            <!-- Fallback: Mặc định giữ lại class PrimeIcon hoặc default nếu ko map trúng -->
            <i *ngSwitchDefault [class]="iconClass || defaultIcon"></i>
          </ng-container>
        </span>
      </ng-template>

      <ng-container *ngFor="let item of menuItems; trackBy: trackByMenu">
        <!-- Item CHA (có items/children) -->
        <li *ngIf="item.items && item.items.length > 0" class="sidebar__item sidebar__item--parent"
          [class.sidebar__item--active-parent]="item.styleClass && item.styleClass.includes('parent_active')">
          <div class="sidebar__link sidebar__link--parent" (click)="toggleMenu(item)" [title]="item.label">
            <span class="sidebar__icon">
              <!-- Gọi Template SVG thay vì thẻ i cũ -->
              <ng-container
                *ngTemplateOutlet="svgIconFallback; context: { iconClass: item.icon, defaultIcon: 'pi pi-folder' }"></ng-container>
            </span>
            <span class="sidebar__label" *ngIf="isSidebarExpanded">{{ item.label }}</span>
            <span class="sidebar__chevron" *ngIf="isSidebarExpanded">
              <i class="pi pi-chevron-down" [class.sidebar__chevron--open]="item.expanded"></i>
            </span>
          </div>

          <!-- Sub-menu (children) -->
          <ul class="sidebar__submenu" [class.sidebar__submenu--open]="item.expanded || !isSidebarExpanded">
            <li *ngFor="let child of item.items; trackBy: trackByMenu" class="sidebar__item sidebar__item--child"
              [class.sidebar__item--active]="child.styleClass && child.styleClass.includes(' active')">
              <a class="sidebar__link sidebar__link--child" [routerLink]="child.routerLink || null"
                [attr.href]="!child.routerLink ? child.path : null" (click)="child.command && child.command()"
                [title]="child.label">
                <span class="sidebar__dot"></span>
                <span class="sidebar__label" *ngIf="isSidebarExpanded">{{ child.label }}</span>
              </a>
            </li>
          </ul>
        </li>

        <!-- Item LÁ (không có children) -->
        <li *ngIf="!item.items || item.items.length === 0" class="sidebar__item sidebar__item--leaf"
          [class.sidebar__item--active]="item.styleClass && item.styleClass.includes(' active')">
          <a class="sidebar__link" [routerLink]="item.routerLink || null"
            [attr.href]="!item.routerLink ? item.path : null" (click)="item.command && item.command()"
            [title]="item.label">
            <span class="sidebar__icon">
              <!-- Gọi Template SVG thay vì thẻ i cũ -->
              <ng-container
                *ngTemplateOutlet="svgIconFallback; context: { iconClass: item.icon, defaultIcon: 'pi pi-circle' }"></ng-container>
            </span>
            <span class="sidebar__label" *ngIf="isSidebarExpanded">{{ item.label }}</span>
          </a>
        </li>
      </ng-container>
    </ul>
  </div>

</nav>